import { Button } from "../../../../core/Button.js";
import { Panel } from "../../../../core/Panel.js";
import { Skeleton } from "../../../../core/Skeleton.js";
import { Amount } from "../../../../domain/Amount.js";
import type { ForgeEarningsContent } from "../../forgeContent.js";

/**
 * What the creator's boxes have earned and not yet been claimed, and the claim into their balance
 * (13 · Exchange, Pick trade-ins' summary band: the number, then the action).
 */
export function ForgeEarnings({
  title,
  description,
  currency,
  cents,
  claim,
}: ForgeEarningsContent) {
  return (
    <Panel size="sm" title={title} description={description}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        {cents === null ? (
          <Skeleton className="h-9 w-32 rounded-sm" />
        ) : (
          <Amount cents={cents} currency={currency} size="lg" className="text-text-primary" />
        )}
        <Button
          variant="primary"
          disabled={claim.disabled}
          loading={claim.busy}
          onClick={claim.onClaim}
          className="max-sm:w-full"
        >
          {claim.label}
        </Button>
      </div>
    </Panel>
  );
}
